query GetCoreEntity($id: ID!) {
    coreEntity(id: $id) {
        ...CoreEntity
    }
}

fragment CoreEntity on CoreEntity {
    id
    type
    name
    avatarUrl
    htmlUrl
    createdTime
}
